module.exports = __webpack_public_path__ + "img/7_42.4501d9b0.png";